module.exports = __webpack_public_path__ + "static/media/save.b8db6f51.svg";